import DimensionControl from '@components/map/controls/DimensionControl';
import { NavigationControl } from '@components/map/controls/NavigationControl';
import { useMapPitchAndBearing } from '@components/map/controls/useMapPitchAndBearing';
import { useMapContext } from '@components/map/MapContext';

export function PitchAndBearingControl() {
  const { mapId } = useMapContext();
  useMapPitchAndBearing(mapId);

  return (
    <>
      <DimensionControl />
      <NavigationControl />
    </>
  );
}
